const Mutations = Object.freeze({
	SET_LOADING: 'grids/gridFieldsSettings/SET_LOADING',
	SET_SELECTED_ENTITY: 'grids/gridFieldsSettings/SET_SELECTED_ENTITY',
	SET_SELECTED_GRID_VIEW: 'grids/gridFieldsSettings/SET_SELECTED_GRID_VIEW',
	ADD_FIELD: 'grids/gridFieldsSettings/ADD_FIELD',
	UPDATE_FIELD: 'grids/gridFieldsSettings/UPDATE_FIELD',
	DELETE_FIELD: 'grids/gridFieldsSettings/DELETE_FIELD',
	SET_EDIT_FIELD: 'grids/gridFieldsSettings/SET_EDIT_FIELD',
	UPDATE_COLUMNS: 'grids/gridFieldsSettings/UPDATE_COLUMNS',
});
//update_columns
export const Actions = Object.freeze({
	LOAD_SELECTED_ENTITY: 'grids/gridFieldsSettings/LOAD_SELECTED_ENTITY',
	CLEAR: 'grids/gridFieldsSettings/CLEAR',
	ADD_FIELD: 'grids/gridFieldsSettings/ADD_FIELD',
	UPDATE_FIELD: 'grids/gridFieldsSettings/UPDATE_FIELD',
	CHECK_FIELD: 'grids/gridFieldsSettings/CHECK_FIELD',
	UPDATE_COLUMNS: 'grids/gridFieldsSettings/UPDATE_COLUMNS',
	DELETE_FIELD: 'grids/gridFieldsSettings/DELETE_FIELD',
	SET_EDIT_FIELD: 'grids/gridFieldsSettings/SET_EDIT_FIELD',
});

export const Getters = Object.freeze({
	GRID_LOADING: 'grids/gridFieldsSettings/GRID_LOADING',
	GET_SELECTED_GRIDVIEW_FIELDS:
		'grids/gridFieldsSettings/GET_SELECTED_GRIDVIEW_FIELDS',
	GET_SELECTED_GRIDVIEW: 'grids/gridFieldsSettings/GET_SELECTED_GRIDVIEW',
	GET_SELECTED_ENTITY: 'grids/gridFieldsSettings/GET_SELECTED_ENTITY',
	GET_EDIT_FIELD: 'grids/gridFieldsSettings/GET_EDIT_FIELD',
});

import { GridsActions } from '../../../../actions';
import Vue from 'vue';

import dataService from '../../../../../services/data/projectGridsService';
import { GeneralActions } from '../../../../actions';

export default {
	state: {
		loading: false,
		selectedEntity: null,
		selectedGridView: null,
		selectedEditField: null,
		currentGridView: null,
	},
	mutations: {
		// [Mutations.UPDATE_COLUMNS](state, Columns) {
		//     state.currentGridView.Columns = Columns;
		// },
		[Mutations.SET_LOADING](state, loading) {
			state.loading = loading;
		},
		[Mutations.SET_SELECTED_ENTITY](state, entity) {
			state.selectedEntity = entity;
		},
		[Mutations.SET_SELECTED_GRID_VIEW](state, item) {
			state.selectedGridView = item;
		},
		[Mutations.ADD_FIELD](state, field) {
			Vue.set(
				state.selectedGridView.GridViewFields,
				state.selectedGridView.GridViewFields.length,
				field
			);
		},
		[Mutations.SET_EDIT_FIELD](state, field) {
			state.selectedEditField = field;
		},
		[Mutations.UPDATE_FIELD](state, field) {
			let fieldId = state.selectedGridView.GridViewFields.findIndex(
				(searchField) => searchField.Id === field.Id
			);
			Vue.set(state.selectedGridView.GridViewFields, fieldId, field);
		},
		[Mutations.DELETE_FIELD](state, id) {
			let fieldId = state.selectedGridView.GridViewFields.findIndex(
				(searchField) => searchField.Id === id
			);
			Vue.delete(state.selectedGridView.GridViewFields, fieldId);
		},
	},
	actions: {
		[Actions.LOAD_SELECTED_ENTITY]({ commit, dispatch }, entity) {
			return new Promise((resolve) => {
				commit(Mutations.SET_SELECTED_ENTITY, entity);
				commit(Mutations.SET_LOADING, true);
				dataService
					.getDefaultGridViewForEntity(entity.Id)
					.then((resp) => {
						commit(Mutations.SET_SELECTED_GRID_VIEW, resp.data);
						commit(Mutations.SET_LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve();
					});
			});
		},
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_EDIT_FIELD, null);
				commit(Mutations.SET_SELECTED_GRID_VIEW, []);
				commit(Mutations.SET_SELECTED_ENTITY, null);
				commit(Mutations.SET_LOADING, false);
				resolve();
			});
		},
		[Actions.SET_EDIT_FIELD]({ commit }, field) {
			commit(Mutations.SET_EDIT_FIELD, field);
		},
		[Actions.ADD_FIELD]({ commit, dispatch }, field) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.postGridField(field)
					.then((resp) => {
						commit(Mutations.ADD_FIELD, resp.data);
						return dispatch(GridsActions.RELOAD_GRID_VIEWS);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.UPDATE_FIELD]({ dispatch, state }, field) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.putGridField(field)
					.then(() => {
						return dispatch(
							Actions.LOAD_SELECTED_ENTITY,
							state.selectedEntity
						);
					})
					.then(() => {
						return dispatch(GridsActions.RELOAD_GRID_VIEWS);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.CHECK_FIELD]({ dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.checkGridField(item)
					.then((resp) => {
						dispatch(GeneralActions.LOADING, false);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.UPDATE_COLUMNS]({ dispatch, state }, data) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateColumns(
						state.selectedGridView.Id,
						data
							.sort((a, b) => a.Order - b.Order)
							.map(({ Id, Order, IsVisible }) => ({
								Id,
								Order,
								IsVisible,
							}))
					)
					.then(() => {
						dispatch(GridsActions.RELOAD_GRID_VIEWS);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.DELETE_FIELD]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteGridField(id)
					.then(() => {
						commit(Mutations.DELETE_FIELD, id);
						return dispatch(GridsActions.RELOAD_GRID_VIEWS);
					})
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve();
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve();
					});
			});
		},
	},
	getters: {
		[Getters.GRID_LOADING]: (state) => {
			return state.loading === true;
		},

		[Getters.GET_SELECTED_ENTITY]: (state) => {
			return state.selectedEntity;
		},
		[Getters.GET_SELECTED_GRIDVIEW_FIELDS]: (state) => {
			if (!state.selectedGridView) return [];
			if (!state.selectedGridView.GridViewFields) return [];

			let items = state.selectedGridView.GridViewFields || [];
			items = items.sort((a, b) => {
				if (a.IsVisible === b.IsVisible) {
					return a.Order > b.Order ? 1 : -1;
				} else {
					return a.IsVisible < b.IsVisible ? 1 : -1;
				}
			});
			return JSON.parse(JSON.stringify(items));
		},
		[Getters.GET_SELECTED_GRIDVIEW]: (state) => {
			return state.selectedGridView;
		},
		[Getters.GET_EDIT_FIELD]: (state) => {
			return state.selectedEditField;
		},
	},
};
